$(document).ready(function() {

	$('div.woocommerce').on('change', '.qty', function() {
		$("[name='update_cart']").trigger('click');
	});

  const priceFormatter = price => new Intl.NumberFormat(document.documentElement.lang, { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(price);

  // Update subtotal on product page
  $( '.variations_form' ).each( function() {

    // when variation is found, do something
    $(this).on( 'found_variation', function( event, variation ) {
        const qtt = $('.qtt-input');
        const subtotal = priceFormatter(parseInt(qtt.val()) * variation.price_to_calculate);
        const subtotalVat = priceFormatter(parseInt(qtt.val()) * variation.price_to_calculate_vat);

        $('#price-wrap').html(variation.price_html_to_replace);
        $('#stock-wrap').html(variation.availability_html);
        qtt.attr('min', variation.min_qty);
        qtt.attr('max', variation.max_qty);
        qtt.attr('data-price-for-subtotal', variation.price_to_calculate);
        $('.calculated-sub-total').text(subtotal);
        $('.calculated-sub-total-vat').text(subtotalVat);
        $('.singleProduct-price .price').addClass('known');
        $('.singleProduct-price .price i').text(priceFormatter(variation.price_to_calculate));

        // per item in bundle
        if (variation.attributes && (variation.attributes['attribute_bundle-of'] || variation.attributes['attribute_pack-of'])) {
          const count = parseInt(variation.attributes['attribute_pack-of'] ? variation.attributes['attribute_pack-of'] : variation.attributes['attribute_bundle-of']);
          const price = priceFormatter(parseFloat(variation.display_price) / count);
          const symbol = $('.woocommerce-Price-currencySymbol').text();

          const priceHtml = `<ins>(${symbol + price} per unit)</ins>`;

          if ($('.singleProduct-price ins').length) {
            $('.singleProduct-price ins').replaceWith(priceHtml);
          } else {
            $(priceHtml).insertAfter('.singleProduct-price var');
          }

        }
    });

		// when variation is found, do something
		$(this).on('found_variation', function(event, variation) {
			const qtt = $('.qtt-input');
			const subtotal = priceFormatter(parseInt(qtt.val()) * variation.price_to_calculate);

			$('#price-wrap').html(variation.price_html_to_replace);
			$('#stock-wrap').html(variation.availability_html);
			qtt.attr('min', variation.min_qty);
			qtt.attr('max', variation.max_qty);
			qtt.attr('data-price-for-subtotal', variation.price_to_calculate);
			qtt.attr('data-price-for-subtotal-vat', variation.price_to_calculate_vat);
			$('.calculated-sub-total').text(subtotal);
			$('.singleProduct-price .price').addClass('known');
			$('.singleProduct-price .price i').text(priceFormatter(variation.price_to_calculate));
		});
	});

	// cart totals
	$( document.body ).on( 'updated_cart_totals', function(e){
		const subtotal = $($('.cart-sammary div[data-title="Subtotal"] bdi')[0]).clone();

    // update cart header
		$('.header-cart .woocommerce-Price-amount.amount bdi').html(subtotal);

    let totalQtt = 0;

    $('.qty').each(function (item) {
      totalQtt += parseInt($(this).val());
    });

    $('.header-cart .cartIcon span').text(totalQtt);
    $('.woocommerce h1 span').text(`(${totalQtt})`);
    
    $.post(wc_cart_params.ajax_url, {action: 'wc_update_header'}, function (data, status) {
      $('.header-cart__hidden').html(data.hidden);
    });
	});
});

//######################
$('.checkout_coupon').on('submit', function() {
	jQuery(document.body).trigger('update_checkout');
});

jQuery(document).ajaxComplete(function() {
	if (jQuery('body').hasClass('woocommerce-checkout') || jQuery('body').hasClass('woocommerce-cart')) {
		jQuery('html, body').stop();
	}
});

// Cart collapse on responsive
$(document.body).delegate('.cart-sammary h2, .cart-shipping h2', 'click', function() {

  if (window.innerWidth < 992) {
    $(this).parent().addClass('open');

    return;
  }

	$(this).parent().toggleClass('open');
});
